<template>
    <b-modal :visible="showAdminModal === 'addEditCity'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 v-if="item">Изменить город {{item.name}}</h4>
            <h4 v-else>Добавить город</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.name.$error }">
                <label for="item-name" class="col-4 col-md-2 col-form-label">Название</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-name"  v-model.trim="newDataItem.name" @input="$v.newDataItem.name.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.name.$error">Название обязательно должно быть указано, минимум {{$v.newDataItem.name.$params.minLength.min}} символа</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.sort.$error }">
                <label for="item-sort" class="col-4 col-md-2 col-form-label">Сортировка</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-sort"  v-model.trim="newDataItem.sort" @input="$v.newDataItem.sort.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.sort.$error">Укажите число</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 col-md-2 col-form-label">Активность города</label>
                <div class="col-8 col-md-4">
                    <label class="switch switch-lg switch-3d switch-primary ml-1">
                        <input v-model="newDataItem.enabled" type="checkbox" class="switch-input">
                        <span class="switch-label"></span>
                        <span class="switch-handle"></span>
                        <small v-if="newDataItem.enabled">включен</small>
                        <small v-else>выключен</small>
                    </label>
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить город</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, numeric } from 'vuelidate/lib/validators'
  import addCityMutate from './../../gql/mutations/AddCity.graphql'
  import updateCityMutate from './../../gql/mutations/UpdateCity.graphql'
//  import modal from 'vue-strap/src/modal'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editCity
      })
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditCity' && this.item) {
          this.setNewDataItem()
        }
        if (val === 'addEditCity' && !this.item) {
          this.clearData()
        }
      }
    },
    data () {
      return {
        loading: false,
        newDataItem: {
          id: null,
          name: '',
          sort: 100,
          enabled: true
        }
      }
    },
    methods: {
      setNewDataItem () {
        this.newDataItem = Object.assign({}, this.item)
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addCityMutate,
          variables: {
            name: this.newDataItem.name,
            sort: this.newDataItem.sort,
            enabled: this.newDataItem.enabled
          }
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Город успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: updateCityMutate,
          variables: {
            id: this.item.id,
            name: this.newDataItem.name,
            sort: this.newDataItem.sort,
            enabled: this.newDataItem.enabled
          }
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Город успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      hideModal () {
        this.$store.commit('SET_ADMIN_EDIT_CITY', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          name: '',
          sort: 100,
          enabled: true
        }
        this.$v.newDataItem.$reset()
      }
    },
    components: {
//      modal
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        sort: {
          required,
          numeric
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditCity.vue?c9523964